module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/palm_left-811eb1b45485405786a236faad68b866.svg";